var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card card-pdv"},[_c('PageHeader',{attrs:{"title":_vm.i18nExtraPointsPerType}}),_c('div',{staticClass:"card-body"},[_c('column-chart',{attrs:{"categories-series-prop":_vm.categories,"series-prop":_vm.series,"hide-legend":true,"busy":_vm.loading}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }